import { checkDiff } from '../../../utils/formValidation/errorCheckingFunctions';

export const validate = (newEntry, initialState) => {
    return checkDiff(newEntry, initialState);
};
